import React from 'react';
import { toCamelCase } from '../../Constants';
import dateFormat from 'dateformat';

const STATE_LABELS = {
    incomplete: 'Incomplet',
    waiting: 'En attente',
    approved: 'Approuvé',
    toCall: 'À appeler',
    reviewed: 'Examiné',
    terminated: 'Terminé',
    canceled: 'Annulé',
    refunded: 'Remboursé',
};

const STATE_COLORS = {
    incomplete: '#ff6b6b',
    waiting: '#ffd93d',
    approved: '#6bcf7f',
    toCall: '#4dabf7',
    reviewed: '#69db7c',
    terminated: '#51cf66',
    canceled: '#fa5252',
    refunded: '#ff8787',
};

const StateBadge = ({ state, notOnlineReason }) => {
    const isNotOnline = state === 'waiting' && notOnlineReason;
    const label = isNotOnline ? 'Indisponible à distance' : (STATE_LABELS[state] || state);
    const bg = isNotOnline ? '#94a3b8' : (STATE_COLORS[state] || '#94a3b8');
    return (
        <span
            style={{
                display: 'inline-block',
                padding: '4px 10px',
                borderRadius: 999,
                background: bg,
                color: '#fff',
                fontSize: 12,
                fontWeight: 600,
                whiteSpace: 'nowrap',
            }}
        >
            {label}
        </span>
    );
};

const RequestsTable = props => {
    const doctorName = (request) => {
        if (!props.user) {
            return `${request.userId.FName} ${request.userId.LName}`;
        }

        return request.doctorId  ? `${request.doctorId.FName} ${request.doctorId.LName}` : 'Aucun';
    };

    return (
        <table className="table">
            <thead>
                <tr>
                    <th>Type</th>
                    <th>{props.user ? 'Docteur' : 'User'}</th>
                    <th>Creation</th>
                    <th>Messages</th>
                    <th>Statut</th>
                </tr>
            </thead>
            <tbody>
                {props.requests.map(request => (
                    <tr
                        key={request._id}
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                            props.history.push('/requests/detail/' + request._id)
                        }
                    >
                        <td>{toCamelCase(request.type)}</td>
                        <td>
                            {doctorName(request)}
                        </td>
                        <td>{dateFormat(request.createdAt, 'dd/mm/yy HH:MM')}</td>
                        <td>{(request.messenger || []).length}</td>
                        <td>
                            <StateBadge state={request.state} notOnlineReason={request.notOnlineReason} />
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default RequestsTable;
